import { React, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./judgeLogin.css";
import Axios from "axios";

const JudgeLogin = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitDisabled, setSubmitDisabled] = useState(false);

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
  };

  const handleVerification = (e) => {
    e.preventDefault();
    setSubmitDisabled(true);
    Axios.post("https://ashish.moodi.org/multicity/mul_judge_login", {
      email,
      password,
    })
      .then((response) => {
        if (response.data.exists) {
          if (response.data.authtoken) {
            localStorage.setItem("judgeauthtoken", response.data.authtoken);
            navigate("/judge/multicity");
            setSubmitDisabled(false);
          } else {
            window.alert("Invalid Password");
          }
        } else {
          window.alert("Invalid Email!");
        }
      })
      .catch((error) => {
        console.error("Error verifying:", error);
      });
  };

  return (
    <>
      <h2>LOGIN PAGE FOR JUDGES</h2>
      <div className="login-container">
        <form className="login-form" onSubmit={handleVerification}>
          <h2>Login</h2>

          <div className="mb-3">
            <label for="exampleInputEmail1" className="form-label">
              Email address
            </label>
            <input
              type="email"
              className="form-control"
              id="exampleInputEmail1"
              aria-describedby="emailHelp"
              onChange={handleEmailChange}
            />
            <div id="emailHelp" className="form-text">
              We'll never share your email with anyone else.
            </div>
          </div>
          <div className="mb-3">
            <label for="exampleInputPassword1" className="form-label">
              Password
            </label>
            <input
              type="password"
              className="form-control"
              id="exampleInputPassword1"
              onChange={handlePasswordChange}
            />
          </div>
          {submitDisabled ? (
            <button
              className="btn btn-primary w-100 mt-3"
              type="submit"
              disabled={submitDisabled}
            >
              <span
                className="spinner-border spinner-border-sm"
                aria-hidden="true"
              ></span>
              <span role="status">Logging in...</span>
            </button>
          ) : (
            <input
              type="submit"
              value="Login"
              className="btn btn-primary w-100 mt-3"
            />
          )}
        </form>
      </div>
    </>
  );
};
export default JudgeLogin;
